import styled from "styled-components";
import ButtonComponent from "../Button";

export const Button = styled(ButtonComponent)`
  display: flex;
`;

export const Icon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 5px;
`;
